module.exports = __webpack_public_path__ + "img/em-title.2f02076a.png";